import type { GRUserState, GRRoundsState, GRUserProgressState } from '../reducers/gr';
import { type GRUserBetslips } from '../reducers/gr';
import { GRChipStatuses } from '../types/chip';
import { type GRRoundState } from '../types/round';

class GRAdventure {
  static hasEnoughPoints = (userState: Partial<GRUserState> | null, rounds: Partial<GRRoundsState>) => {
    if (!userState || !rounds) {
      return false;
    }

    const { progress = {} as GRUserProgressState, round: roundId, betslips } = userState;

    if (roundId && betslips) {
      const currentRound = progress[roundId];
      const roundRules = rounds[roundId];

      if (currentRound && roundRules) {
        const { bets } = currentRound;
        const { requiredPoints } = roundRules;

        if (bets?.length) {
          const potentialPoints = bets.reduce((total, current) => {
            let currentOdds = 1;

            if (current.status === GRChipStatuses.WON || current.status === GRChipStatuses.PENDING) {
              currentOdds = betslips[current.betslipReference].odds;
            }

            const currentTotal = (100 * currentOdds * total) / 100;
            return +currentTotal.toFixed(2);
          }, 100);

          return potentialPoints >= requiredPoints;
        }
      }
    }

    return false;
  };

  static hasRoundAnyPendingBetslipWithSameMatchId = ({
    round,
    matchId,
    userBetslips,
  }: {
    round: GRRoundState | undefined;
    matchId: number;
    userBetslips: Partial<GRUserBetslips> | undefined;
  }): boolean => {
    if (round && userBetslips) {
      const { bets: roundBets } = round;

      return roundBets.some((bet) => {
        const { status } = bet ?? {};

        if (status === GRChipStatuses.PENDING) {
          const { betslipReference } = bet;

          const betslip = userBetslips[betslipReference];

          if (betslip) {
            const { matchIds: betslipMatchIds } = betslip;

            if (~betslipMatchIds.indexOf(matchId)) {
              return true;
            }
          }
        }

        return false;
      });
    }

    return false;
  };
}

export default GRAdventure;
